import * as Yup from "yup";
import { PickupConsigneeSchema, PickupItemSchema } from "../../../../app/data/pickup/models";
import { validationMessages } from "../../../../app/data/common/validationMessages";

const bolRefsSchema = {
  bolNumber: Yup.string()
    .matches(/(\w+|-+)/, validationMessages.notValid)
    .max(20, "The value must be no more than 20 characters")
    .required(validationMessages.required),
  poNumber: Yup.string()
    .matches(/(\w+|-+)/, validationMessages.notValid)
    .max(12, "The value must be no more than 12 characters"),
  additionalReference: Yup.string()
    .matches(/(\w+|-+)/, validationMessages.notValid)
    .max(25, "The value must be no more than 25 characters"),
  pickupDate: Yup.string().required(validationMessages.required),
  pickupReadyTime: Yup.string().required(validationMessages.required),
  pickupCloseTime: Yup.string().required(validationMessages.required),
  specialInstructions: Yup.string()
    .matches(/(\w+|-+)/, validationMessages.notValid)
    .max(150, "The value must be no more than 150 characters"),
};

const shipperAddressSchema = Yup.object({
  name: Yup.string().required(validationMessages.required).max(36, "The value must be no more than 36 characters"),
  addressLine_1: Yup.string().required(validationMessages.required).max(256, "The value must be no more than 255 characters"),
  city: Yup.string().required(validationMessages.required).max(64, "The value must be no more than 64 characters"),
  state: Yup.string().required(validationMessages.required),
  zip: Yup.string()
    .matches(/^\d*$/, validationMessages.notValid)
    .min(5, "The value must be no less than 5 digits")
    .max(5, "The value must be no more than 5 digits")
    .required(validationMessages.required),
  addressLine_2: Yup.string().matches(/(\w+|-+)/, validationMessages.notValid).max(150, "The value must be no more than 150 characters"),
  phoneNumber: Yup.string()
    .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid)
    .max(25, "The value must be no more than 25 characters"),
  email: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid).required(validationMessages.required),
});

const consigneeAddressSchema = Yup.object({
  name: Yup.string().required(validationMessages.required).max(36, "The value must be no more than 36 characters"),
  addressLine_1: Yup.string().required(validationMessages.required).max(256, "The value must be no more than 255 characters"),
  city: Yup.string().required(validationMessages.required).max(64, "The value must be no more than 64 characters"),
  state: Yup.string().required(validationMessages.required),
  zip: Yup.string()
    .matches(/^\d*$/, validationMessages.notValid)
    .min(5, "The value must be no less than 5 digits")
    .max(5, "The value must be no more than 5 digits")
    .required(validationMessages.required),
  addressLine_2: Yup.string().matches(/(\w+|-+)/, validationMessages.notValid).max(150, "The value must be no more than 150 characters"),
  phoneNumber: Yup.string()
    .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid)
    .required(validationMessages.required),
  email: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid),
});

const bolItemRowSchema = Yup.object({
  packageType: Yup.string().required(validationMessages.required),
  numberOfUnits: Yup.string()
    .matches(/^\d+$/, validationMessages.notValid)
    .required(validationMessages.required),
  weight: Yup.string()
    .matches(/^\d+(\.\d+)?$/, validationMessages.notValid)
    .required(validationMessages.required),
  ratingClass: Yup.string().required(validationMessages.required),
  description: Yup.string(),
  length: Yup.string().matches(/^\d*$/, validationMessages.notValid),
  width: Yup.string().matches(/^\d*$/, validationMessages.notValid),
  height: Yup.string().matches(/^\d*$/, validationMessages.notValid),
  notes: Yup.string(),
  sidemark: Yup.string(),
});

export const BolReviewFormSchema = Yup.object({
  ...bolRefsSchema,
  pickupFrom: shipperAddressSchema,
  shipTo: consigneeAddressSchema,
  items: Yup.array().of(bolItemRowSchema).min(1, validationMessages.required),
});

/** Re-export for commodity row deep validation against ItemModel shape */
export { PickupConsigneeSchema, PickupItemSchema };
